import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listItemIoT: null,
};

const chartSlice = createSlice({
  name: "chart",
  initialState,
  reducers: {
    setListItemIoT: (state, { payload }) => {
      state.listItemIoT = payload;
    },
  },
});
// the action
export const { setListItemIoT } = chartSlice.actions;

//the reducer
export default chartSlice.reducer;
